export default function DashboardReports({ children, className = '' }) {
    return <div className={`portal-dashboard-reports ${className}`}>{children}</div>;
}
